<template>
  <div class="module filter">
    <div class="container">
      <div class="filter__main">

        <router-link class="filter__close" :to="{name: 'Workouts'}">
            <icon name="close" class="filter__close__icon"></icon>
        </router-link>

        <div class="filter__row">

          <div class="filter__column filter__column--multi">

            <div class="filter__set">
              <div class="filter__set__title h6" v-translate>level</div>
              <div class="filter__pills">
                <div 
                  class="filter__pill" 
                  v-for="levelFilter in levelFilters" 
                  :key="levelFilter.id"
                  @click="toggleFilter('levels', levelFilter.name, levelFilter.id)"
                  :class="{'is-selected': isFilterActive('levels', levelFilter.id)}"
                >
                    {{levelFilter.name}}
                </div>
              </div>
            </div>

            <div class="filter__set">
              <div class="filter__set__title h6" v-translate>duration</div>
              <div class="filter__slider">
                <div class="filter__slider__values">
                    <div class="filter__slider__value">{{durationMinFormatted}}</div>
                    <div class="filter__slider__value">{{durationMaxFormatted}}</div>
                </div>
                <vue-slider  class="filter__slider__control" :dotSize="20" :contained="true" v-model="durationFilter" :min="durationMin" :max="durationMax" :interval="300" tooltip="none" :tooltip-formatter="formatDuration" :enableCross="false" ></vue-slider>
              </div>
            </div>

          </div>
        
          <div class="filter__column filter__column--single">
            <div class="filter__set">
              <div class="filter__set__title h6" v-translate>goal</div>
              <loader v-if="!goals.length" size="small"></loader>
              <div v-else class="filter__pills">
                <div 
                  class="filter__pill" 
                  v-for="goalFilter in goals" 
                  :key="goalFilter.id"
                  @click="toggleFilter('goals', goalFilter.name, goalFilter.id)"
                  :class="{'is-selected': isFilterActive('goals', goalFilter.id)}"
                >
                    {{goalFilter.name}}
                </div>
              </div>
            </div>
          </div>

          <div class="filter__column filter__column--single">
            <div class="filter__set">
              <div class="filter__set__title h6" v-translate>type_of_workout</div>
              <loader v-if="!interests.length"  size="small"></loader>
              <div v-else class="filter__pills">
                <div 
                  class="filter__pill" 
                  v-for="interestFilter in interests" 
                  :key="interestFilter.id"
                  @click="toggleFilter('interests', interestFilter.name, interestFilter.id)"
                  :class="{'is-selected': isFilterActive('interests', interestFilter.id)}"
                >
                    {{interestFilter.name}}
                </div>
              </div>
            </div>
          </div>

        </div>


        <div class="filter__row">
            <div class="filter__set">
              <div class="filter__set__title h6" v-translate>trainer</div>
              <loader v-if="!trainers || !trainers.length"  size="small"></loader>
              <div v-else class="filter__pills">
                <div 
                  class="filter__pill filter__pill--grey  filter__pill--trainer" 
                  v-for="trainer in trainers" 
                  :key="trainer.id"
                  @click="toggleFilter('trainers', trainer.name, trainer.id)"
                  :class="{'is-selected': isFilterActive('trainers', trainer.id)}"
                >
                    <div class="filter__pill__image" :style="'background-image: url('+ trainer.profileImageUrl +');'"></div>
                    <div class="filter__pill__name">{{trainer.name}}</div>
                </div>
              </div>
            </div>
        </div>

      </div>
    </div>
<!-- 
    <div class="filter__actions" @click="applyFilters">
        <div class="container">
            <div class="filter__actions__inner">
                <div class="filter__actions__apply h6" v-translate>apply_filters</div>
                <div class="filter__actions__clear" @click.stop="clearFilters" v-translate>clear_all</div>
            </div>
        </div>
    </div> -->
  </div>
</template>

<script>
import * as api from '../api'
import { mapGetters } from 'vuex'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import { addTrackingObject } from "@/utils/tracking"

export default {
    components: {
        VueSlider
    },
    data() {
      return {
        levelFilters: [
          {
            'id': 'beginner',
            'name': this.$gettext('beginner')
          },
          {
            'id': 'intermediate',
            'name': this.$gettext('intermediate')
          },
          {
            'id': 'advanced',
            'name': this.$gettext('advanced')
          },
        ],
        durationFilter: [0 * 60, 60 * 60],
        durationMin: 0 * 60,
        durationMax: 60 * 60,
        durationMinFormatted: false,
        durationMaxFormatted: false,
        activeFilters: {
            levels: [],
            goals: [],
            interests: [],
            duration: {},
            trainers: []
        },
      }
    },
    created() {
        this.fetchGoals();
        this.fetchInterests();
        this.getInitialFilters();
        this.formatDurations();
            this.$store.commit('setFilters', this.activeFilters);
    },
    computed: {
        ...mapGetters(['trainers', 'goals', 'interests', 'filters'])
    },
    watch: {
        durationFilter(val) {
            this.formatDurations();
            this.setDuration(val);
        },
        activeFilters: {
            handler(val){
                if(val.duration.from === undefined) {
                    this.setDefaultDurationFilter();
                }
            },
            deep: true
        }
    },
    methods: {
        getInitialFilters() {
            if(this.filters.levels.length || this.filters.goals.length || this.filters.interests.length || this.filters.trainers.length || this.filters.duration.from !== undefined){
                this.activeFilters = this.filters;
                if(this.filters.duration.from !== undefined) {
                    this.durationFilter[0] = this.filters.duration.from;
                    this.durationFilter[1] = this.filters.duration.to;
                }
            }
        },
      toggleFilter(type, name, id) {
        let filterObject = {name, id, type}
        let filterObjectIndex = this.activeFilters[type].findIndex(obj => obj.id === id);
        
        if(filterObjectIndex >= 0) {
            this.activeFilters[type].splice(filterObjectIndex, 1);
        } else {
            this.activeFilters[type].push(filterObject);
        }
        
        // tracking
        addTrackingObject({subSection: "home", screenName: "searchWorkoutsResults"}, {type: "filter", value: `web_${type}_filter`});
      },
      async fetchGoals() {
            if(this.goals.length) {
                return false;
            }
            try {
                const response = await api.goals();
                this.$store.commit('setGoals', response.data.data);
            } catch (error) {
                console.error(error);
            }
        },
        async fetchInterests() {
            if(this.interests.length) {
                return false;
            }
            try {
                const response = await api.interests();
                this.$store.commit('setInterests', response.data.data);
            } catch (error) {
                console.error(error);
            }
        },
        formatDuration(duration) {
            let minutes = duration / 60;
            let response = '';
            if(minutes < 60) {
                response = `${minutes} ${this.$gettext('min_abbr')}`;
            } else {
                // let hours = minutes / 60;
                // let fullHours = Math.floor(hours);
                // let restHour = hours - fullHours;
                // let restMinutes = Math.round(restHour * 60);
                // response = `${fullHours} h`;
                // if(restMinutes) {
                //     response += ` ${restMinutes} min`;
                // }
                response = this.$gettext('any_duration');
            }
            return response;
        },
        formatDurations() {
            this.durationMinFormatted = this.formatDuration(this.durationFilter[0]);
            this.durationMaxFormatted = this.formatDuration(this.durationFilter[1]);
        },
        isFilterActive(type, id) {
            return this.activeFilters[type].filter(f => f.id === id).length;
        },
        setDuration(duration) {
            let filterObject;
            if(duration[0] === this.durationMin && duration[1] === this.durationMax) {
                filterObject = {};
            } else {
                filterObject = {
                    type: 'duration',
                    id: 'duration',
                    from: duration[0],
                    to: duration[1],
                    name: this.durationMinFormatted + ' — ' + this.durationMaxFormatted
                }
            };
            this.activeFilters.duration = filterObject;

            // tracking
            addTrackingObject({subSection: "home", screenName: "searchWorkoutsResults"}, {type: "filter", value: `web_duration_filter`});
        },
        applyFilters() {
            this.$store.commit('setFilters', this.activeFilters);
            this.scrollToResults();
        },
        clearFilters() {
            this.activeFilters = {
                levels: [],
                goals: [],
                interests: [],
                duration: {},
                trainers: []
            };
            this.applyFilters();
        },
        setDefaultDurationFilter() {
            if(this.durationFilter[0] !== this.durationMin || this.durationFilter[1] !== this.durationMax) {
                this.durationFilter = [this.durationMin, this.durationMax];
            }
        },
        scrollToResults() {
            let rect = this.$el.getBoundingClientRect();
            let top = rect.bottom + window.pageYOffset - 40;
            
            window.scroll({
                top: top,
                left: 0,
                behavior: 'smooth'
            });
        },
    }
}
</script>

<style lang="scss" scoped>
.filter {
  background-color: rgba(#000, 0.05);
  &__main {
    padding-top: 40px;
    position: relative;
    @include mq($until: notebook) {
        padding-top: 25px;
    }
  }
  &__close {
      transition: 0.2s;
    position: absolute;
    right: 0;
    padding: 0 0 1em 1em;
    cursor: pointer;
    .no-touch &:hover {
        opacity: 0.5;
    }
  }
  &__row {
    display: flex;
    flex-wrap: wrap;
  }
  &__column {
    width: 33.3%;
    &--single {
        @include mq($until: notebook) {
            width: 50%;
        }
        @include mq($until: tablet) {
            width: 100%;
        }
    }
    &--multi {
        @include mq($until: notebook) {
            width: 100%;
            display: flex;
            .filter{
                &__set {
                    width: 50%;
                }
            }
        }
        @include mq($until: tablet) {
            display: block;
            .filter{
                &__set {
                    width: 100%;
                }
            }
        }
    }
  }
  &__set {
    margin-bottom: 30px; 
    padding-right: 30px;
    @include mq($until: notebook) {
        margin-bottom: 15px; 
    }
    @include mq($until: tablet) {
        padding-right: 0;
    }
    &__title {
      text-transform: uppercase;
      margin-bottom: 0.7em; 
    }
  }
  &__pills {
    display: flex;
    flex-wrap: wrap;
  }
  &__pill {
    transition: 0.2s;
    padding: 0.3em 0.9em;
    border: 1px solid $puma-color-neutral-20;
    border-radius: 30px;
    margin-right: 0.5em;
    margin-bottom: 0.5em;
    font-size: $puma-size-font-sm;
    cursor: pointer;
    user-select: none;
    @include mq($until: notebook) {
        margin-right: 0.4em;
        margin-bottom: 0.4em;
    }
    @include mq($until: tablet) {
        font-size: $puma-size-font-sm;
    }
    .no-touch &:hover {
      border-color: $puma-color-black;
    }
    &--grey {
        background-color:rgba(#000, 0.1);
        border: 0;
        .no-touch &:hover {
            background-color:rgba(#000, 0.15);
        }
    }
    &--trainer {
        display: flex;
        padding: 0;
    }
    &.is-selected {
        background-color: $puma-color-black !important;
        border-color: $puma-color-black !important;
        color: $puma-color-white !important;
    }
    &__image {
        width: 2.1em;
        height: 2.1em;
        background-size: cover;
        border-radius: 50px;
    }
    &__name {
        padding: 0.3em 0.9em;
    }
  }
  &__slider {
      margin-top: 10px;
      padding-right: 30px;
        @include mq($until: tablet) {
            padding-right: 0;
        }
        &__values {
            display: flex;
            width: 100%;
            justify-content: space-between;
            margin-bottom: 5px;
        }
        &__value {
            font-size: $puma-size-font-sm;
        }
  }
  &__actions {
      transition: 0.1s;
      background-color: rgba(#000,0.1);
      cursor: pointer;
      .no-touch &:hover {
        background-color: rgba(#000,0.15);
        .filter__actions {
            &__clear {
                color: $puma-color-neutral-80;
                &:hover {
                    color: $puma-color-black;
                }
            }
        }
      }
      &__inner {
          display: flex;
          position: relative;
          align-items: center;
          justify-content: center;
      }
      &__apply {
          text-transform: uppercase;
          padding: 0.8em 4em;
          user-select: none;
      }
      &__clear {
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-60%);
          user-select: none;
          cursor: pointer;
        &::after {
            content: '';
            position: absolute;
            top: 100%;
            left: 0;
            width: 100%;
            height: 1px;
            background-color: currentColor;
        }          
      }

  }
}
</style>